import { useRef } from 'react';
import { Search } from 'lucide-react';
import type { ElementNodeDto } from '@xshop/shared';
import { useElementRender, type ElementBoxAttrs } from './elementRenderContext';
import { inStoreLanguage, shopWords } from '../../commerce/shopWords';
import { textProp, urlProp } from './elementProps';
import { useListingWords } from './listingWords';
import './elementSearchField.css';

// The search element laid out as a field on the page, as Sleek's search page has it: a grey pill with the
// glyph, the words searched for, and Clear. It is a plain GET form to the results page, so it works before
// any script runs and every result page has its own address.

/** What the field is drawn with: the element, and the box its styles land on. */
type SearchFieldProps = { node: ElementNodeDto; box: ElementBoxAttrs };

// Draws the field, holding the words the address was searched for.
export const SearchField: React.FC<SearchFieldProps> = ({ node, box }) => {
  const words = useListingWords();
  const input = useRef<HTMLInputElement>(null);
  const label = inStoreLanguage(textProp(node.props, 'ariaLabel', ''), 'Search', shopWords(useElementRender().store?.language).search);
  const asked = new URLSearchParams(window.location.search).get('q') ?? '';
  const clear = () => { if (input.current) { input.current.value = ''; input.current.focus(); } };
  return (
    <form {...box} role="search" className={[box.className, 'xe-search-field'].filter(Boolean).join(' ')} action={urlProp(node.props, 'action') ?? '/search'} method="get">
      <Search size={20} strokeWidth={1.5} aria-hidden="true" />
      <input ref={input} type="search" name="q" defaultValue={asked} aria-label={label} autoComplete="off" placeholder={textProp(node.props, 'placeholder', 'Search products')} />
      <button type="button" className="xe-search-field-clear" onClick={clear}>{words.clear}</button>
    </form>
  );
};
